import React from 'react';
import { MapIcon, UtensilsIcon, ClockIcon } from 'lucide-react';
import { trackPurchaseClick } from '../utils/MetaPixel';
export const Hero = () => {
  return <section className="bg-gradient-to-b from-teal-50 to-white py-10 sm:py-16 px-4 sm:px-6 lg:px-8" data-id="element-217">
      <div className="max-w-7xl mx-auto" data-id="element-218">
        <div className="block md:hidden mb-8" data-id="element-219">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qcd14hzumgTezoFuZPmCJj/01b9dd3d-81af-4f44-8956-979fb6224594.png" alt="Familia cocinando con Airfryer" className="rounded-lg shadow-xl w-full" data-id="element-220" />
        </div>
        <div className="flex flex-col lg:flex-row items-center gap-8" data-id="element-221">
          <div className="lg:w-1/2 space-y-5 text-center lg:text-left" data-id="element-222">
            <div className="bg-teal-100 text-teal-800 px-4 py-2 rounded-lg inline-block text-sm font-semibold mb-2 mx-auto lg:mx-0" data-id="element-223">
              Revisado por: Lic. Sofía Manfrini – Nutritionist, UBA
            </div>
            <h1 className="text-3xl md:text-5xl font-bold text-gray-900 leading-tight" data-id="element-224">
              Recetario Fit para Airfryer
              <span className="block text-teal-600 text-2xl md:text-3xl mt-2" data-id="element-225">
                + 6 bonos gratis solo por hoy
              </span>
            </h1>
            <h2 className="text-xl md:text-3xl font-semibold text-teal-600" data-id="element-226">
              +60 recetas en menos de 15 min
            </h2>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 text-sm text-gray-700 bg-gray-50 p-3 rounded-lg" data-id="element-227">
              <span className="font-bold" data-id="element-228">4.9/5 ⭐️</span>
              <span className="mx-1" data-id="element-229">|</span>
              <span data-id="element-230">+2,800 descargas en USA</span>
              <span className="mx-1" data-id="element-231">|</span>
              <span data-id="element-232">8 de cada 10 lo usan 4+ veces por semana</span>
              <span className="mx-1" data-id="element-233">|</span>
              <span data-id="element-234">Actualizaciones gratis de por vida</span>
            </div>
            <div className="space-y-4" data-id="element-235">
              <div className="flex items-center justify-center lg:justify-start gap-3" data-id="element-236">
                <MapIcon className="h-6 w-6 text-teal-600 flex-shrink-0" data-id="element-237" />
                <p className="text-lg text-gray-700" data-id="element-238">
                  ¿Tienes airfryer pero no el mapa?
                </p>
              </div>
              <div className="space-y-2" data-id="element-239">
                <div className="flex items-center justify-center lg:justify-start gap-3" data-id="element-240">
                  <UtensilsIcon className="h-5 w-5 text-gray-600 flex-shrink-0" data-id="element-241" />
                  <p className="text-gray-700" data-id="element-242">Tienes el aparato.</p>
                </div>
                <div className="flex items-center justify-center lg:justify-start gap-3" data-id="element-243">
                  <ClockIcon className="h-5 w-5 text-gray-600 flex-shrink-0" data-id="element-244" />
                  <p className="text-gray-700" data-id="element-245">Tienes las ganas.</p>
                </div>
              </div>
              <p className="text-lg font-medium text-gray-800" data-id="element-246">
                Pero algo falta… y ya lo sientes.
              </p>
            </div>
            <p className="text-gray-700 italic" data-id="element-247">
              "Recetas simples, balanceadas y pensadas para la vida real: poco
              tiempo, mucho sabor y porciones claras."
            </p>
            <div className="pt-4 flex justify-center lg:justify-start" data-id="element-248">
              <a href="https://organicecomm.com/cart/51818275930293:1" className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 text-lg w-full sm:w-auto text-center" onClick={e => {
              trackPurchaseClick();
            }} target="_blank" rel="noopener noreferrer" data-id="element-249">
                Quiero cocinar más rápido (y rico)
              </a>
            </div>
            <p className="text-sm text-gray-600 text-center lg:text-left" data-id="element-250">
              Ahorra tiempo y dinero: menos comida rápida, más comida casera en
              &lt;15 min.
            </p>
          </div>
          <div className="hidden md:block lg:w-1/2 mt-6 lg:mt-0" data-id="element-251">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qcd14hzumgTezoFuZPmCJj/01b9dd3d-81af-4f44-8956-979fb6224594.png" alt="Familia cocinando con Airfryer" className="rounded-lg shadow-xl w-full" data-id="element-252" />
          </div>
        </div>
      </div>
    </section>;
};